// extracted by mini-css-extract-plugin
module.exports = {"container":"post-item_container__rvekc","vote":"post-item_vote__B6Yzi","title":"post-item_title__1Ve0V","created":"post-item_created__1xtAT"};